import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    Circle as CircleIcon,
    Warning as WarningIcon,
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
} from '@mui/icons-material';

const StyledBadge = styled(Box)(({ theme, status }) => {
    const statusStyles = {
        active: {
            color: theme.palette.primary.main,
            backgroundColor: '#e3f2fd',
        },
        pending: {
            color: theme.palette.warning.main,
            backgroundColor: '#fff3e0',
        },
        overdue: {
            color: theme.palette.error.main,
            backgroundColor: '#ffebee',
        },
        settled: {
            color: theme.palette.success.main,
            backgroundColor: '#e8f5e9',
        },
        legal: {
            color: '#7b1fa2',
            backgroundColor: '#f3e5f5',
        },
    };

    const style = statusStyles[status] || statusStyles.active;

    return {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: 4,
        fontSize: '0.75rem',
        fontWeight: 600,
        color: style.color,
        backgroundColor: style.backgroundColor,
    };
});

const statusIcons = {
    active: CircleIcon,
    pending: WarningIcon,
    overdue: ErrorIcon,
    settled: CheckCircleIcon,
    legal: WarningIcon,
};

const LsStatusBadge = ({ status, label, showIcon = true, ...props }) => {
    const Icon = statusIcons[status] || CircleIcon;

    return (
        <StyledBadge status={status} {...props}>
            {showIcon && <Icon sx={{ fontSize: '1rem' }} />}
            <Typography variant="inherit">{label || status?.toUpperCase()}</Typography>
        </StyledBadge>
    );
};

export default LsStatusBadge;